import { useEffect, useState } from "react";
import servicosColaborador from "../servicos/servicos-colaborador";
import NavMenu from "./components/Nav";
import { useContext } from "react";
import AuthContext from '../servicos/autorizacao/AuthContex';
import servicosSolicitacao from "../servicos/servicos-solicitacao";
import { toast, ToastContainer } from "react-toastify";
import NavMobile from "./components/NavMobile";
import { basePath } from "../utils/baseUrl";

const CarrinhoGestor = () => {
    const { user } = useContext(AuthContext);
    const [carrinho, setCarrinho] = useState([]);
    const [flagAlteracaoCarrinho, setFlagAlteracaoCarrinho] = useState(false);
    const [total, setTotal] = useState(0);
    const [pontuacaoAtual, setPontuacaoAtual] = useState();

    useEffect(() => {
        const getDados = () => {
            servicosColaborador.getTotalPontos(user.id)
                .then(response => {
                    if (response.status === 200) {
                        setPontuacaoAtual(response.data.pontosAtivos)
                    }
                }).catch(error => {
                    console.log(error);
                })
        }
        getDados();
    }, [pontuacaoAtual, user.id]);


    useEffect(() => {
        let carrinhoJSON = localStorage.getItem('carrinho_gestor');

        let carrinho = JSON.parse(carrinhoJSON);

        setCarrinho(carrinho);
        let total = 0;
        if (carrinho?.produtos.length > 0) {
            for (const iterator of carrinho?.produtos) {
                let sub = Number(iterator.qtd) * Number(iterator?.produto?.Produto[0]?.milhas);
                total += sub;
            }

        }
        setTotal(total);

    }, [flagAlteracaoCarrinho]);

    const removerItem = (index) => {
        flagAlteracaoCarrinho === true ? setFlagAlteracaoCarrinho(false) : setFlagAlteracaoCarrinho(true);
        carrinho.produtos.splice(index, 1);

        localStorage.setItem('carrinho_gestor', JSON.stringify(carrinho));

        setCarrinho(carrinho);
    };


    const solicitarTroca = () => {
        let confirmacao = window.confirm("Você confirma a solicitação de troca?");


        if (confirmacao === true && carrinho.produtos.length > 0) {
            // eslint-disable-next-line no-unused-vars
            let flagSol = false;

            for (const iterator of carrinho.produtos) {
                const solicitacao = {
                    "id_colaborador": user.id,
                    "id_produto": iterator.produto.id_produto,
                    "data_solicitacao": new Date()
                }
                // eslint-disable-next-line no-loop-func
                servicosSolicitacao.solicitarTroca(solicitacao).then(response => {
                    if (response.data.status === true) {
                        toast.success(`Solicitação de troca do produto ${iterator.produto.Produto[0].nome} efetuada com sucesso!`);
                    } else {
                        toast.error('Não foi possível efetuar a solicitação de troca!');
                        flagSol = true;
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(`Não foi possível efetuar  a solicitação de troca para ${iterator.produto.Produto[0].nome}!`)
                })
            }
            localStorage.removeItem('carrinho_gestor');
        }
        flagAlteracaoCarrinho === true ? setFlagAlteracaoCarrinho(false) : setFlagAlteracaoCarrinho(true);

    }


    const CarrinhoVazio = () => {
        return <>
            <div className="" style={{ height: '70vh' }}>
                <div className="text-center">
                    <span className="subtitulo" style={{ fontSize: 20 }}>Seu carrinho está vazio, que tal ir até a lista de produtos para adicionar alguns?</span>
                </div>
                <div className="text-center mt-4">
                    <span><a href="/SolicitacoesGestor" className="btn-icones rounded-3 p-1">Voltar</a></span>
                </div>
            </div>
        </>
    }

    const ListaProdutos = () => {
        let qtd = carrinho?.produtos !== undefined ? carrinho?.produtos?.length : 0;

        return <>

            {qtd > 0 ? <div className="d-flex justify-content-center mt-5">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {carrinho?.produtos?.map((item, index) => {
                            return (
                                <tr key={index} >
                                    <td width={150} >
                                        <img
                                            className="me-3 mb-3 rounded-3"
                                            style={{ width: 100, height: 100 }}
                                            src={`${basePath}/${item.produto.filename}`}
                                            alt={item.produto.filename}
                                        />
                                    </td>
                                    <td width={100}><span className="me-2">{item.produto.Produto[0].nome}</span></td>
                                    <td width={50}><input
                                        className="text-center rounded-3"
                                        style={{ width: 30 }}
                                        max={item.produto.Produto[0].estoque}
                                        value={1}
                                        disabled
                                    /></td>

                                    <td width={100} className="text-center">
                                        <span className="ms-3">{item.produto.Produto[0].milhas}</span>
                                    </td>

                                    <td>
                                        <span className="ms-3">{item.produto.Produto[0].tamanho}</span>
                                    </td>
                                    <td width={100}><button className="ms-3 btn-icones rounded-2 p-1" onClick={() => removerItem(index)}>Remover</button></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div> : <CarrinhoVazio />}
        </>
    }
    return (
        <>
            <ToastContainer />
            <NavMenu />
            <div className="container">
                
                <div className="d-flex justify-content-center align-items-center text-center mb-4 mt-4">
                    <span className="subtitulo" style={{ fontSize: 22 }}>Total do pedido: </span>
                    <span style={{ fontSize: 25 }} className="subtitulo2 ms-2">{total} milhas</span>
                    <span className="subtitulo ms-4" style={{ fontSize: 22 }}>Saldo: </span>
                    <span style={{ fontSize: 25 }} className="subtitulo2 ms-2">{pontuacaoAtual} milhas</span>
                </div>

                <ListaProdutos />
                {total > 0 && <div className="d-flex justify-content-center align-items-center mt-3">
                    <button onClick={() => solicitarTroca()} className="text-center btn-icones rounded-2 p-1">Confirmar pedido</button>
                </div>}
            </div>
            <NavMobile />
        </>
    );
};


export default CarrinhoGestor;